"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 24 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 *
 * @author Jaroslav Sevcik
 */


var CompetitorPriceRawDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorPriceRawDataConverter, _DataObjectConverter_);

  function CompetitorPriceRawDataConverter() {
    _classCallCheck(this, CompetitorPriceRawDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceRawDataConverter).apply(this, arguments));
  }

  return CompetitorPriceRawDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorPriceRawDataConverter = CompetitorPriceRawDataConverter;